'use client';

import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { TileCard } from './TileCard';
interface WebsiteTileProps {
  className?: string;
  title: string;
  description: string;
  href: string;
  imageSrc?: string;
  onClick?: () => void;
}
export default function WebsiteTile(t0) {
  const $ = _c(10);
  const {
    className,
    title,
    description,
    href,
    imageSrc,
    onClick
  } = t0;
  let t1;
  if ($[0] !== imageSrc || $[1] !== title) {
    t1 = imageSrc ? <Image src={imageSrc} alt={`${title} website preview`} fill={true} sizes="(min-width: 1024px) 33vw, (min-width: 640px) 50vw, 100vw" className="object-cover transition-transform group-hover:scale-105" /> : <div className="size-full bg-gradient-to-br from-zinc-200 to-zinc-300 dark:from-zinc-700 dark:to-zinc-800"><div className="flex size-full items-center justify-center"><div className="text-sm text-zinc-500 dark:text-zinc-400">Website Preview</div></div></div>;
    $[0] = imageSrc;
    $[1] = title;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== className || $[4] !== description || $[5] !== href || $[6] !== onClick || $[7] !== t1 || $[8] !== title) {
    t2 = <TileCard href={href} title={title} description={description} className={className} external={true} onClick={onClick}>{t1}</TileCard>;
    $[3] = className;
    $[4] = description;
    $[5] = href;
    $[6] = onClick;
    $[7] = t1;
    $[8] = title;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
}